"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextSchema = void 0;
/**
 *  The validation schema for a text object.
 */
exports.TextSchema = {
    type: 'object',
    required: [
        'key',
    ],
    properties: {
        guid: { type: ['string', 'null'] },
        key: { type: 'string', minLength: 4, maxLength: 255 },
        content: { type: ['string', 'null'] },
    },
};
//# sourceMappingURL=text.schema.js.map